import React, {useContext, useState} from 'react';
import {CollapsibleSection, joinClassNames, SegmentedButton, SelectInput, Size, TextArea, TextInput} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import HelpIcon from "../../HelpIcon/HelpIcon";
import HelpText from "../../HelpIcon/HelpText";
import Icons from "../../../../misc/Icon";
import IconTypes from "../IconInput/IconTypes";

const propTypes = {};
const defaultProps = {};

const SearchInput = () => {
	const {configuratorStore} = useContext(MobXContext);
	const [isExpanded, setIsExpanded] = useState(false);

	const isConfigured = configuratorStore.searchIconType !== IconTypes.none;

	return (
		<div className="configurator__inputs__input">
			<CollapsibleSection
				clickSection={() => setIsExpanded(!isExpanded)}
				expanded={isExpanded}
				title={`Search${isConfigured ? ' - configured' : ''}`}
				collapsibleIndicator={Icons.iconArrowRight()}
				className={joinClassNames(isConfigured ? 'configured' : undefined, 'mb1')}
			>
				<SegmentedButton
					className="segmented-button full-width"
					field="searchIconType"
					label="Search Type"
					onChange={configuratorStore.setFieldValue}
					options={[
						{label: 'None', value: IconTypes.none},
						{label: 'Custom', value: IconTypes.onClick},
						{label: 'Popup', value: IconTypes.popupContent},
					]}
					showLabel={false}
					value={configuratorStore.searchIconType}
					children={
						<HelpIcon
							popOverText={HelpText.searchIconType}
							onUseExampleField={'searchIconType'}
							onUseExampleFieldValue={configuratorStore.setFieldValue}
						/>
					}
				/>
				{
					configuratorStore.searchIconType === IconTypes.none ? undefined : (
						<>
							<TextInput
								size={Size.FULL_WIDTH}
								field="searchTitle"
								label="Title"
								value={configuratorStore.searchTitle}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={HelpText.searchTitle}
										onUseExampleField="searchTitle"
										onUseExampleFieldValue={configuratorStore.setFieldValue}
									/>
								}
							/>
							<SelectInput
								size={Size.FULL_WIDTH}
								field="searchShowTitle"
								label="Show Title"
								options={[
									{label: 'No', value: false},
									{label: 'Yes', value: true},
								]}
								value={configuratorStore.searchShowTitle}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={HelpText.searchShowTitle}
										onUseExampleField="searchShowTitle"
										onUseExampleFieldValue={configuratorStore.setFieldValue}
									/>
								}
							/>
						</>
					)
				}
				{
					configuratorStore.searchIconType === IconTypes.onClick ?
						<TextArea
							size={Size.FULL_WIDTH}
							field="searchOnClick"
							label="Search Icon onClick"
							value={configuratorStore.searchOnClick}
							onChange={configuratorStore.setFieldValue}
							children={
								<HelpIcon
									popOverText={HelpText.searchOnClick}
									onUseExampleField="searchOnClick"
									onUseExampleFieldValue={configuratorStore.setFieldValue}
								/>
							}
						/>
						: undefined
				}
				{
					configuratorStore.searchIconType === IconTypes.popupContent ?
						<>
							<TextInput
								size={Size.FULL_WIDTH}
								field="searchPlaceholder"
								label="Placeholder"
								value={configuratorStore.searchPlaceholder}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={HelpText.searchPlaceholder}
										onUseExampleField="searchPlaceholder"
										onUseExampleFieldValue={configuratorStore.setFieldValue}
									/>
								}
							/>
							<TextArea
								size={Size.FULL_WIDTH}
								field="searchCallback"
								label="Searched Callback"
								value={configuratorStore.searchCallback}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={HelpText.searchCallback}
										onUseExampleField="searchCallback"
										onUseExampleFieldValue={configuratorStore.setFieldValue}
									/>
								}
							/>
						</>
						: undefined
				}
			</CollapsibleSection>
		</div>
	);
};

SearchInput.propTypes = propTypes;
SearchInput.defaultProps = defaultProps;

export default observer(SearchInput);
